import React from 'react';

const ServiceSeoTab = ({
  serviceForm,
  setServiceForm,
  addSeoVariant,
  updateSeoVariant,
  removeSeoVariant,
  activateSeoVariant,
  addSeoKeyword,
  updateSeoKeyword,
  removeSeoKeyword,
}) => (
  <div className="space-y-4">
    <div className="bg-blue-50 p-3 rounded-lg text-sm">
      <strong>SEO-оптимизация:</strong> Эти данные используются для улучшения позиций в поисковых системах (Яндекс, Google).
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Meta Title (RU) <span className="text-gray-400 font-normal">— заголовок в поиске</span>
      </label>
      <input
        type="text"
        value={serviceForm.seo_title_ru}
        onChange={(e) => setServiceForm({ ...serviceForm, seo_title_ru: e.target.value })}
        placeholder="Лицензия Минпромторга — Оформление «под ключ» | ВЕЛОКС ХИНТ"
        className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500"
        data-testid="seo-title-ru"
      />
      <p className="text-xs text-gray-500 mt-1">
        Рекомендуемая длина: 50-60 символов. Сейчас: {serviceForm.seo_title_ru?.length || 0}
      </p>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Meta Description (RU) <span className="text-gray-400 font-normal">— описание в поиске</span>
      </label>
      <textarea
        value={serviceForm.seo_description_ru}
        onChange={(e) => setServiceForm({ ...serviceForm, seo_description_ru: e.target.value })}
        rows={3}
        placeholder="Помощь в получении лицензий Минпромторга для ВЭД. Сроки от 2 дней, гарантия результата..."
        className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500"
        data-testid="seo-description-ru"
      />
      <p className="text-xs text-gray-500 mt-1">
        Рекомендуемая длина: 150-160 символов. Сейчас: {serviceForm.seo_description_ru?.length || 0}
      </p>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Keywords (RU) <span className="text-gray-400 font-normal">— ключевые слова через запятую</span>
      </label>
      <textarea
        value={serviceForm.seo_keywords_ru}
        onChange={(e) => setServiceForm({ ...serviceForm, seo_keywords_ru: e.target.value })}
        rows={2}
        placeholder="лицензия минпромторга, оформление лицензии, ВЭД, импорт, экспорт"
        className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500"
        data-testid="seo-keywords-ru"
      />
    </div>

    {/* Alternative SEO Variants */}
    <div className="border-t pt-4">
      <div className="flex justify-between items-center mb-3">
        <h4 className="font-medium">Альтернативные варианты Title/Description</h4>
        <button
          type="button"
          onClick={() => addSeoVariant('ru')}
          className="text-sm text-orange-600 hover:text-orange-700"
          data-testid="add-seo-variant-btn"
        >
          + Добавить вариант
        </button>
      </div>
      <p className="text-xs text-gray-500 mb-3">
        Создайте несколько вариантов для тестирования. Нажмите "Активировать" чтобы применить вариант.
      </p>
      {serviceForm.seo_variants_ru?.map((variant, idx) => (
        <div key={idx} className="bg-gray-50 p-3 rounded-lg mb-3 space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-700">Вариант {idx + 1}</span>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => activateSeoVariant('ru', idx)}
                className="text-xs text-green-600 hover:text-green-700 font-medium"
                data-testid={`activate-seo-variant-${idx}`}
              >
                Активировать
              </button>
              <button
                type="button"
                onClick={() => removeSeoVariant('ru', idx)}
                className="text-xs text-red-500 hover:text-red-600"
                data-testid={`remove-seo-variant-${idx}`}
              >
                Удалить
              </button>
            </div>
          </div>
          <input
            type="text"
            value={variant.title}
            onChange={(e) => updateSeoVariant('ru', idx, 'title', e.target.value)}
            placeholder="Альтернативный Title"
            className="w-full px-3 py-1.5 border rounded text-sm"
          />
          <textarea
            value={variant.description}
            onChange={(e) => updateSeoVariant('ru', idx, 'description', e.target.value)}
            placeholder="Альтернативный Description"
            rows={2}
            className="w-full px-3 py-1.5 border rounded text-sm"
          />
        </div>
      ))}
      {(!serviceForm.seo_variants_ru || serviceForm.seo_variants_ru.length === 0) && (
        <p className="text-sm text-gray-400 text-center py-2">Нет альтернативных вариантов</p>
      )}
    </div>

    {/* Additional Keywords */}
    <div className="border-t pt-4">
      <div className="flex justify-between items-center mb-3">
        <h4 className="font-medium">Дополнительные ключевые фразы</h4>
        <button
          type="button"
          onClick={() => addSeoKeyword('ru')}
          className="text-sm text-orange-600 hover:text-orange-700"
          data-testid="add-seo-keyword-btn"
        >
          + Добавить фразу
        </button>
      </div>
      <p className="text-xs text-gray-500 mb-3">
        Фразы для расширенного охвата. Используйте для планирования контента и отслеживания позиций.
      </p>
      <div className="space-y-2">
        {serviceForm.seo_keywords_extra_ru?.map((keyword, idx) => (
          <div key={idx} className="flex gap-2">
            <input
              type="text"
              value={keyword}
              onChange={(e) => updateSeoKeyword('ru', idx, e.target.value)}
              placeholder="Ключевая фраза..."
              className="flex-1 px-3 py-1.5 border rounded text-sm"
            />
            <button
              type="button"
              onClick={() => removeSeoKeyword('ru', idx)}
              className="text-red-500 px-2 hover:text-red-600"
              data-testid={`remove-seo-keyword-${idx}`}
            >
              ×
            </button>
          </div>
        ))}
      </div>
      {(!serviceForm.seo_keywords_extra_ru || serviceForm.seo_keywords_extra_ru.length === 0) && (
        <p className="text-sm text-gray-400 text-center py-2">Нет дополнительных фраз</p>
      )}
    </div>

    <div className="border-t pt-4">
      <h4 className="font-medium mb-3">English SEO (optional)</h4>
      <div className="space-y-3">
        <input
          type="text"
          value={serviceForm.seo_title_en}
          onChange={(e) => setServiceForm({ ...serviceForm, seo_title_en: e.target.value })}
          placeholder="Meta Title (EN)"
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 text-sm"
          data-testid="seo-title-en"
        />
        <textarea
          value={serviceForm.seo_description_en}
          onChange={(e) => setServiceForm({ ...serviceForm, seo_description_en: e.target.value })}
          rows={2}
          placeholder="Meta Description (EN)"
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 text-sm"
          data-testid="seo-description-en"
        />
        <input
          type="text"
          value={serviceForm.seo_keywords_en}
          onChange={(e) => setServiceForm({ ...serviceForm, seo_keywords_en: e.target.value })}
          placeholder="Keywords (EN)"
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 text-sm"
          data-testid="seo-keywords-en"
        />
      </div>
    </div>
  </div>
);

export default ServiceSeoTab;
